module.exports = __webpack_public_path__ + "resources/img/img_security_shellcop.ef7fa5dd468adbb468b0b4ff9d72392a.png";